import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmState } from '../models/ConfirmState';
import { MsgOptions } from '../models/MsgOptions';
import { MsgOptionsCookie } from '../models/MsgOptionsCookie';
import { ConfirmModalComponent } from '../../framework/modals/components/confirm-modal/confirm-modal.component';
import { ConfirmPublicModalComponent } from '../../framework/modals/components/confirm-public-modal/confirm-public-modal.component';
import { CookieModalComponent } from '../../framework/modals/components/cookie-modal/cookie-modal.component';
import { PrimitiveModalComponent } from '../../framework/modals/components/primitive-modal/primitive-modal.component';


@Injectable()
export class DialogService {
    popup(url: string, big = false, w = 550, h = 350): Window {
        let t = 150;
        let l = 100;
        if (big) {
            w = screen.availWidth;
            h = screen.availHeight - 100;
            t = 0;
            l = 0;
        }
        return window.open(
            url,
            'win',
            'toolbar=0,location=0,directories=0,status=0,titlebar=0,menubar=0,scrollbars=1,resizable=0,width=' +
            w +
            ',height=' +
            h +
            ',top=' +
            t +
            ',left=' +
            l
        );
    }
    constructor(private modalService: NgbModal, private state: ConfirmState) { }
    confirm(options: MsgOptions): Promise<any> {
        this.state.options = options;
        this.state.modal = this.modalService.open(ConfirmModalComponent, {
            centered: options.centered,
            backdrop: options.backdrop
        });
        return this.state.modal.result;
    }
    confirmpublic(
        options: MsgOptions,
        labelyes: string,
        labelno: string
    ): Promise<any> {
        this.state.labelyes = labelyes;
        this.state.labelno = labelno;
        this.state.options = options;
        this.state.modal = this.modalService.open(ConfirmPublicModalComponent, {
            centered: true
        });
        return this.state.modal.result;
    }

    close() {
        this.modalService.dismissAll();
    }
    showCookies(options: MsgOptionsCookie) {
        this.state.cookieOptions = options;

        this.state.modal = this.modalService.open(CookieModalComponent, {
            centered: true,
        });
    }
    showPrimitiveModal(options: MsgOptions) {
        this.state.options = options;
        this.state.modal = this.modalService.open(PrimitiveModalComponent, {
            centered: true,
        });
    }
}
